import { get } from 'lodash';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import NotificationsApi from 'client/api/v2/NotificationsApi';
import Vue from 'vue';

const initialState = () => ({
  notificationsCount: 0,
});

export const createNotificationsCollection = (api = NotificationsApi) => ({
  namespaced: true,
  state: initialState(),
  actions: {
    async fetchNotificationsCount({ commit, dispatch }) {
      try {
        const notifications = await api.fetch();
        const notificationsCount = get(notifications, 'totalCount', 0);
        commit('SET_NOTIFICATIONS_COUNT', notificationsCount);
      } catch {
        dispatch(`${notificationModule}/triggerErrorNotification`, {
          title: 'Unable to retrieve notifications',
        }, { root: true });
      }
    },
  },
  mutations: {
    SET_NOTIFICATIONS_COUNT(state, notificationsCount) {
      Vue.set(state, 'notificationsCount', notificationsCount);
    },
  },
});

export default createNotificationsCollection();
